export const slides = [
  {
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/WmXjvI6fm3hpzzMEZ1M2v/9d162c5d6f91e8e6c2b4c48e89be673b/0_-_Once_Upon_a_Farm_Cover.jpg",
  },

  {
    title: "St. Maries Lavender Farm and Distillery",
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/3Ysf5SGoshZPpoKpPUfTOQ/1ebb551f4af0aee0a895050e42b86c74/01_St-Maries.jpg",

    content: `
      <p>Our legacy began in 1992, when Founder D. Gary Young planted unhybridized seeds from Provence, France, on the now 200 acres of land in St. Maries, Idaho. This is where the modern essential oils movement took root.</p>
      <p>Oils like Melissa from this farm are used in signature blends like Kidscents&reg; Geneyus&trade;</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/3XeFLdVZXsNhhQmAXa8qk/e91a0ed417e7988b95fc5fa41ed8c0e2/OnceUponaFarmSiloUS___1.jpg" class="" alt=""/>
      <ul>
      <li>Give your children more pep in their step as you diffuse GeneYus to and from activities with the Car Vent Diffuser.</li>
      <li>Apply it to your child&rsquo;s wrists before school to help give them a fresh aromatic boost.</li>
      </ul>
      </div>
     `,
    pdf: "https://static.youngliving.com/Farms/St.Maries_US.pdf",
  },

  {
    title: "Mona Lavender Farm and Distillery",
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/4UNpgOY4jJDO4hDNsDvHD5/8bd1ad8191f4bbe2b6edf6e8b89bcaa2/02_Mona.jpg",

    content: `
      
  <p>Spanning nearly 1,700 acres and home to one of the largest privately owned essential oil distilleries in the world, the sprawling fields in Mona, Utah, are a short drive from Young Living Global Headquarters. This farm&rsquo;s distillery boasts a closed-loop water cooling system that saves approximately 260 million gallons of water a year.</p>
  <p>Oils like Clary Sage and Goldenrod are also from this farm.</p>
  <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/lT7tFdYcW2XBH1iotRLUt/c776eb3bd87dd562060d5adf0c269b25/OnceUponaFarmSiloUS___2.jpg" class="" alt=""/>
  <ul>
  <li>Take your bubble baths to elite status by adding 5 drops of Juniper.</li>
  <li>Reduce the appearance of blemishes by adding a couple of drops to your daily skin care routine.</li>
  </ul>
  </div>
     `,
    pdf:
      "https://static.youngliving.com/Farms/MonaYoungLivingLavenderFarm_US_Global.pdf",
  },

  {
    index: 3,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/2yN69ZZmExuaXPfiebaIMm/5dd3f07e4bef5a71b04452e8969bdd7c/03_Simaine-la-Rotonde.jpg",
    title: "Simiane-La-Rotonde Lavender Farm and Distillery",
    pdf:
      "https://static.youngliving.com/Farms/Simiane-la-rotonde_France_US.pdf",
    content: `<p>Located in charming Provence, France, the Simiane-la-Rotonde Lavender Farm and Distillery uses sheep to weed its fields, leaving the essential oil-producing plants unharmed. Surrounded by breathtaking views, this idyllic part of France attracts artists, essential oil lovers, and history bus.</p>
      <p>Oils like Lavender and Lavandin are also from this farm</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/1Vstu66pwLfapwD7Mj0UPC/ad0c1e2819fa0a02b3d59f617ae86795/OnceUponaFarmSiloUS___3.jpg" class="" alt=""/>
      <ul>
      <li>Combat winter hair by combining with coconut oil for an at-home hair mask.</li>
      <li>Kick your feet up and diffuse this floral oil while applying Clary Sage-infused Dragon Time&trade;.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 4,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/fvMTWK5dWp3Yh25ch4lB1/ee47b2a37052d5908d5000927903393e/04_Highland-Flats.jpg",
    title: "Highland Flats Tree Farm and Distillery",
    pdf: "https://static.youngliving.com/Farms/HighlandFlats_US.pdf",
    content: `
      <p>Home to beautiful conifer trees that produce essential oils reminiscent of the great outdoors, the Highland Flats Tree Farm and Distillery also features a registered way station habitat for monarch butterflies migrating between Canada and the Yucatan Peninsula.</p>
      <p>Oils like White Fir from this farm are used in signature blends like Grounding&trade;</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/1bnnBwXCLPPvzV1ITPWAMf/f8a9ff7c1695707dfbecfd7357e13b1c/OnceUponaFarmSiloUS__4.jpg" class="" alt=""/>
      <ul>
      <li>Fill your home with the scent of a foresty meadow by diffusing Grounding morning and night.</li>
      <li>Add a drop to the front of your yoga mat before starting your practice of stability and spirituality.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 5,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/6NcxxmXj0WV3xRnibaMyBB/e921958a67093f2798c0cd2fc44ba99b/5_-_Finca-Botanica-Chongon-EC.jpg",
    title: "Finca Botanica Farm and Distillery",
    pdf: "https://static.youngliving.com/Farms/Finca_Botanica_US.pdf",
    content: `<p>The Finca Botanica Farm and Distillery spans over 1,000 acres and thrives in Ecuador&rsquo;s tropical climate, featuring rich soil, year-round harvests, and lush botanical life. This farm in Chongon grows Ecuadorian lemongrass, which boasts a similar citrusy scent to the bottle of Lemongrass you&rsquo;re receiving today.</p>
      <p>Oils like Ylang Ylang And Palo Santo are from this farm.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/5qDW2FAoWTp4TYeICje8A7/454d0a6864a4bdda5c8aac2ae078d1bb/OnceUponaFarmSiloUS__5.jpg" class="" alt=""/>
      <ul>
      <li>Let this clean-smelling scent help you relax as you spend time prepping for holiday feasts.</li>
      <li>Give yourself a pre-pedi treatment by adding it to body wash for its skin-cleansing properties.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 6,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/7HDNWzWzZILwIvsJ4SvC3F/5461bd6096455e3e4e4b23b1860d0f4a/6_-_Outback-Darwin-AU.jpg",
    title: "Outback Botanical Reserve and Distillery",
    pdf:
      "https://static.youngliving.com/Farms/Outback-Botanical-Farm-US-EN.pdf",

    content: `<p>Australia&rsquo;s Northern Territory outback is the backdrop for Australian cypress pine trees that can live up to 200 years. The blue cypress located at the Outback Botanical Reserve and Distillery has a fresh scent similar to other evergreens.</p>
      <p>Oils like Blue Cypress from this partner are used in signature blends like Release&trade;</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/5zhzktMW6fHk7EFz7BhsZm/ff50a374249cc97182fd4f155435dd73/OnceUponaFarmSiloUS__6.jpg" class="" alt=""/>
      <ul>
      <li>Add it to Epsom salt and a steamy bath as you soak away life&rsquo;s worries.</li>
      <li>Diffuse it in the living room and kitchen when you invite loved ones over.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 7,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/2y408vxzoXnTLkBPaCNKMS/efeb79f7e58bae4ee66b935f2fe3e43f/7_-_D-Gary-Young-Foundation-EC.jpg",
    title: "The D. Gary Young, Young Living Foundation",
    pdf: "https://static.youngliving.com/Farms/Foundation-US-EN.pdf",
    content: `
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/1jDCcdTZxHtcxVNI3bzVib/82101f9c9b70dff75879cd84fa3aa654/OnceUponaFarmSiloUS__7.jpg" class="" alt=""/>
      <p>One of the Young Living Foundation's core focus areas is to empower women by investing in fair-trade enterprises so they can help their children thrive. We are proud to invest in Free Women, an organization in the United States that provides more than 40 refugee women with vital, stable employment as they cultivate prosperous new beginnings.</p>
      </div>
  
      `,
  },
  {
    index: 8,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/4CD8Tadnf1G8aBB7iTUqYh/114526d0bb040d26a9dc2f6a1c3e1fde/8_-_Arabian-Muscat-Oman.jpg",
    title: "Arabian Frankincense Distillery",
    pdf:
      "https://static.youngliving.com/Farms/Arabian-Frankincense-Distillery-US-EN.pdf",
    content: `<p>After travelling to Oman in 1995, Gary and Mary Young discovered the rich history of Sacred Frankincense&trade; and its many wellness benefits. Young Living became the first company in the world to extract and export Omani Sacred Frankincense oil for the Western world. Today, this time-tested oil is produced at the Arabian Frankincense Distillery in the shadow of limestone cliffs, under an orange sky.</p>
      <p>Oils like Sacred Frankincense produced at this distillery are used in signature blends like Freedom&trade;.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/2hUj9bIEqWA33x3DrIKR3G/1042be6b44c0976a4a148b5057a3c08b/OnceUponaFarmSiloUS_8.jpg" class="" alt=""/>
      <ul>
      <li>Reflect on the day and unwind for the night by diffusing it while journaling or meditating.</li>
      <li>Massage it into feet before bed while you&rsquo;re feeling freedom from everyday troubles.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 9,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/afKxt365FEr7VfVFZ7lAx/55f00b2f06e226d88ee2c1218c39cfff/09_taiwan.jpg",
    title: "Taiwan Cooperative Farm and Distillery",
    pdf: "https://static.youngliving.com/Farms/Taiwan-FINAL-US-EN.pdf",
    content: `<p>The Taiwan Cooperative Farm and Distillery is made up of smaller individual farm operations that focus on a variety of botanicals. After a century of deforestation, each farm nurtures and restores much of Taiwan&rsquo;s unique plant life. Thanks to these Taiwanese farms, Young Living can provide our members with rich oils like Camphor Wood to add depth to some of our signature blend.</p>
      <p>Oils like Camphor Wood from this co-op are used in signature blends like Valor&reg;</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/6T492s5OVeRqFMFKhs7Hc4/58ca9cc5fd84d7b8372bcc1a97aec423/OnceUponaFarmSiloUS_9.jpg" class="" alt=""/>
      <ul>
      <li>Use this versatile oil during mornings by the fire and evenings spent chatting with family.</li>
      <li>Wear Valor as a subtle cologne or use it as a base for a personalized winter scent.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 10,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/1EYCoy4d7uWwu2UPStWln9/3a09469676d46f258b19ce050c879da6/10_-_Northern-Lights-BC-CA.jpg",
    title: "Northern Lights Farm and Distillery",
    pdf:
      "https://static.youngliving.com/Farms/Northern-Lights-Farm&Distillery-US-EN.pdf",
    content: `<p>With the pristine wilderness backdrop of Northern British Columbia, Canada, the Northern Lights Farm and Distillery rests on land free of synthetic chemicals and fertilizers. With a horticulture license and coordination with local governments, the farm also manages the preservation of nearby forests.</p>
      <p>Oils like Northern Lights Black Spruce from this farm are used in signature blends like Peace &amp; Calming II&trade;</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/221ayD6gn8cs5mIhHOGp86/f3be659599494f01242f46c6643b4dfe/OnceUponaFarmSiloUS_10.jpg" class="" alt=""/>
      <ul>
      <li>Fill your life with good feelings by diffusing this feels-like-a-hug aroma.</li>
      <li>Use with Young Living Bath &amp; Shower Gel Base for a sudsy wash the whole family will love.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 11,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/1n6DHqzE3Z5cG9xem5UKrt/6c1e28661f32a3a256df0cc53effdbe2/11_-_Kona-Sandalwood-Hawaii-US.jpg",
    title: "Kona Sandalwood Reforestation Project",
    pdf: "https://static.youngliving.com/Farms/Kona-US-EN.pdf",
    content: `<p>Young Living&rsquo;s partnership with the Kona Sandalwood Reforestation Project exemplifies the importance of preserving cultural values. Only dead or dying sandalwood is harvested for essential oil to maintain the ecological balance. This follows the deeply rooted Hawaiian belief in humanity&rsquo;s responsibility to maintain a respectful relationship with the land.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/4kSpmYJEueFJtdsZil2Vdu/d8a05e3d74f1e2fe68673f16dc0940da/OnceUponaFarmSiloUS_11.jpg" class="" alt=""/>
      <p>Oils like Royal Hawaiian Sandalwood&trade; provided by this partner are used in products along side Royal Hawaiian Sandalwood&trade; Hydrosol</p>
      </div>
      `,
  },
  {
    index: 12,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/5KRvSKRhge7PrlFJ9C14si/ef14544595b81fafd5302322b9f60fa4/24_-_Golden-Einkorn-Sault-FR.jpg",
    title: "Skyrider Wilderness Ranch",
    pdf: "https://static.youngliving.com/Farms/Skyrider-US-EN.pdf",
    content: `<p>Nestled in the hills of Tabiona, Utah, the Skyrider Wilderness Ranch held a special place in Gary Young&rsquo;s heart. The plants are sustainably pollinated by 8&ndash;12 bee colonies that call the ranch home, helping to maintain a healthy ecosystem and a thriving source of einkorn.</p>
      <div class="slide-medialist">
     
      <p>Einkorn grain harvested from this ranch is used in products like Gary&rsquo;s True Grit&reg; Einkorn Flour, Flakes, and Spaghetti.</p>
      </div>
      `,
  },
  {
    index: 13,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/dXOoxokFkeyDuo58OZeMY/29b0b726993e2f9dfbe6d7dd17dd3d82/13_-_Dalmatia-Split-Croatia.jpg",
    title: "Dalmatia Aromatic Farm and Distillery",
    pdf: "https://static.youngliving.com/Farms/Dalmatia-US-EN.pdf",
    content: `<p>Founded with the intent to become a sustainable source for Helichrysum essential oil, the Dalmatia Aromatic Farm and Distillery has since been home to even more native, aromatic botanicals, including Dalmation Sage. While this bottle of Sage is not from this Croatian farm, it honors that legacy.</p>
      <p>Oils like Laurus Nobilis Vitality&trade; are distilled at this farm.</p>
      <div class="slide-medialist">
    
      <ul>
      <li>Diffuse in the kitchen to make the house smell like holiday feasting and extravagant cooking.</li>
      <li>Dilute with V-6&trade; and rub on the bottoms of feet when your tootsies are tuckered out.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 14,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/3HaZChDqmhvcpqvMj2DDkc/7f53b8942b601cfb41fdaccca9cc5148/14_-_Ord-River-Sandalwood-Farm-Kununurra-AU.jpg",
    title: "Ord River Sandalwood Farm and Distillery",
    pdf:
      "https://static.youngliving.com/Farms/Ord-River-Sandalwood-Farm&Distillery-US-EN.pdf",
    content: `<p>Extending across Australia&rsquo;s gorgeous outback, the Ord River Sandalwood Farm and Distillery is the world&rsquo;s largest sandalwood distillery. Recycling over 50 million liters of water since 2010, this farm earned the prestigious Champion Award from the Western AU Water Corp and sustainably cultivates Sacred Sandalwood&trade; oil.</p>
      <p>Oils like Sacred Sandalwood from this farm are used in signature blends like Loyalty:</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/4Aq9ixcu2f8nJHJprXolB8/5ef20a25070b6e8663878f87bda5cf5c/OnceUponaFarmSiloUS_14.jpg" class="" alt=""/>
      <ul>
      <li>Get in the groove by diffusing it in a classroom, workspace, or at-home office.</li>
      <li>Get out of your comfort zone by applying 1&minus;2 drops to your wrists and chest before big moments.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 15,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/4JGsqCM5RQc1buEuRnDdUg/c0f8d59540f93d1416cf0e59257f8d64/15_-_Amanzi-Amahle-ZA.jpg",
    title: "Amanzi Amahle Cooperative Farm and Distillery",
    pdf: "https://static.youngliving.com/Farms/Amanzi-Amahle-US-EN.pdf",
    content: `<p>Headquartered in the Witwatersrand hills of South Africa, the Amanzi Amahle Cooperative Farm and Distillery works with local growers of South Africa to produce some of Young Living&rsquo;s most popular essential oils. This partnership provides the valuable instruction and resources smaller farms need to produce high-quality essential oils, while also dedicating efforts to the conscientious treatment of the people, land, and natural resources.</p>
      <p>Oils like Tea Tree and Grapefruit are also provided by this co-op.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/3mcLdQ9XdHf5di0o6rLF2m/8466793c681d9305b3382a7765863f31/OnceUponaFarmSiloUS_15.jpg" class="" alt=""/>
      <ul>
      <li>Seek out smoother skin with a few drops in your&nbsp;face wash&nbsp;as part of your nighttime skin care routine.</li>
      <li>Freshen breath by adding 1 drop of Orange&nbsp;to 1 tablespoon of water. Swish for up to 1 minute and spit out.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 16,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/5BUwCL3VK5WTqTkEJTbanD/b9b1a6f4bbc2741c7f50a807120d762d/16__-Labbeemint-Washington-US.jpg",
    title: "Labbeemint Partner Distillery",
    pdf: "https://static.youngliving.com/Farms/Labbeemint-US-EN.pdf",
    content: `<p>The Labbeemint Partner Distillery has been producing world-class mint oils at its family-run facility since the 1940s. This partner remains a sustainable source of high-quality mint essential oils you can trust.</p>
      <p>Oils like Peppermint provided by this partner are used in signature blends like R.C.&trade;</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/5W2eXAQdKUQayJZpukGOUf/b29483d15af5372a272081db1a073f02/OnceUponaFarmSiloUS_16.jpg" class="" alt=""/>
      <ul>
      <li>Rub it on the back of your neck before a workout for a refreshing boost of fragrance.</li>
      <li>Brighten your outlook during early morning errands by applying it to your chest and wrists.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 17,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/4dISQ8cO0cUQDz99uSFocK/9982c92a9b82b2dde6433aa9a903600f/17_-_Finca-Victoria-Ciudad-Victoria-MX.jpg",
    title: "Finca Victoria Farm",
    pdf: "https://static.youngliving.com/Farms/Finca-Victoria-US-EN.pdf",
    content: `<p>Stretching 2,400 acres, with 50 groves of hand-tended fruit trees, the Finca Victoria Farm in Ciudad Victoria, Mexico, proudly operates using innovative techniques to further support their zero-waste initiatives. Fresh lime rinds are cold pressed to produce pure Lime essential oil.</p>
      <p>Oils like Lime provided from this farm are used in signature blends like Stress Away.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/kBHrzIXW44Yvf5d0hRSFS/817be1d06997250eb70ee51024189191/OnceUponaFarmSiloUS_17.jpg" class="" alt=""/>
      <ul>
      <li>Diffuse its soothing aroma while conquering homework, career projects, and holiday errands.</li>
      <li>Add a few drops to coconut oil to give your hair a shiny, smooth appearance.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 18,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/5OMtDPJAty5RUG3Ygsqlbb/4026054e543c10b6691fd3227f4b2a46/18_-_Happy-Pili-PH.jpg",
    title: "Happy Pili Tree Farm and Distillery",
    pdf: "https://static.youngliving.com/Farms/Happy-Pili-US-EN.pdf",
    content: `<p>Young Living partners with the Happy Pili Tree Farm and Distillery because of their ethical and sustainable harvesting and fair wages to workers. This partnership also protects natural resources, which ensures long-term viability of high-quality Elemi oil and keeps job opportunities and expertise within the community.</p>
      <p>Oils like Elemi from this farm are used in signature products like Cool Azul&reg;Pain Relief Cream:</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/4SKiYe40aY7ThoAlczkWuT/de1729ba9130ef8813d2f5745b229eb1/OnceUponaFarmSiloUS_18.jpg" class="" alt=""/>
      <ul>
      <li>Diversify your ohm session with Elemi by diffusing it during meditation.</li>
      <li>Add 3 drops of Elemi to your daily moisturizer for an even-looking complexion.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 19,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/4QeXkbUAnB4DzoQo6QKSNv/de480b6df464924a8cb277f5d1fc9978/19_Vida-deSeville.jpg",
    title: "Vida de Seville Distillery",
    pdf: "https://static.youngliving.com/Farms/Vida-De-Seville-US-EN.pdf",
    content: `<p>The Vida De Seville Distillery, located near the city of Seville, employs sustain able zero-waste practices. Infusing passion and craft into the distillation process, this distillery produces the highest-quality products, like Frankincense and Myrrh essential oil, with the purity nature intended.</p>
      <p>Oils like Cistus and Frankincense are also provided by this partner.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/5MyUkMS56Yudy9PwYz1YMZ/64b5f13430469e0094ff9edc120f5a5d/OnceUponaFarmSiloUS_19.jpg" class="" alt=""/>
      <ul>
      <li>Diffuse it in the evening as you and your loved ones unwind together.</li>
      <li>Mix a couple of drops in your favorite lotion to make it feel high-end.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 20,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/6CubKexZy4IDpXL2XPZ6aa/86d7969b5028a43b1f78e9059fd1034d/20_-_Mera-Ocotea-Pastaza-EC.jpg",
    title: "Mera Ocotea Farm",
    pdf: "https://static.youngliving.com/Farms/Mera-Ocotea-US-EN.pdf",
    content: `<p>Spanning 120 acres in Ecuador's Pastaza Province, the farm relies on year-round rainfall and non-GMO seeds cultivated with natural pollination. Home to 5,000 native ocotea trees, it will be a sustainable source of Ocotea essential oil, which contains the naturally occurring alpha-humulene that is commonly used for its soothing, comforting benefits.</p>
      <p>Oils like Ocotea are used in signature products like Awaken&trade;</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/6IMV2eJGljglvK3pstKGVZ/c147760a2334c4128d5730e017873058/OnceUponaFarmSiloUS_20.jpg" class="" alt=""/>
      <ul>
      <li>Diffuse it to elevate your surroundings and inspire greater connectedness.</li>
      <li>Combine with a&nbsp;carrier oil&nbsp;and massage it into your neck and shoulders when you &ldquo;knead&rdquo; to unwind.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 21,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/5hh8Rf3GkuMaKU6V6SLzJr/7cf38a8c463de51a3235444909b17a4e/21_-_Bella-Vista-Calabria-Italy.jpg",
    title: "Bella Vista Farm",
    pdf:
      "https://static.youngliving.com/Farms/BellaVistaOnceUponAFarm_EN_US.pdf",
    content: `<p>Founded in the early 1930s, the Bella Vista Farm leverages southern Italy&rsquo;s sunny climate, using solar energy to power its buildings during the offseason. Situated in Reggio Calabria, the region produces over 80 percent of the world&rsquo;s Bergamot essential oil.</p>
      <p>The cold-pressed bergamot peels from this farm are also used in internal oils such as Bergamot Vitality&trade;</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/7t8nngcnM4q0UtSxOKXy81/47ec6bd7aa09b441af12489643b7a47c/OnceUponaFarmSiloUS_21.jpg" class="" alt=""/>
      <ul>
      <li>Kick a soda craving or curb your sweet tooth by adding it to water.&nbsp;</li>
      <li>Sweeten from-scratch goods by using a few drops in tarts, muffins, and pastries.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 22,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/5VPmviBwgAf1nWZxDFeI3t/80ec394f6ad44da04cc3facac65ea539/22_-_Kalipay-Coconut-Polillo-Is-PH.jpg",
    title: "Kalipay Coconut Farm",
    pdf: "https://static.youngliving.com/Farms/KalipayCoconutFarm_EN-US.pdf",
    content: `<p>Located in the tropical landscape of the Philippines, Kalipay is dedicated to empowering the local community, donating a portion of its annual profits to fight generational poverty through education and leadership programs. Green chemistry is used to eliminate waste in the production of coconut oil used in Young Living roll-ons.</p>
      <p>Oils like Coconut Oil from this farm are used in signature products like Breathe Again&trade; Roll-On.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/7DK108QvLniGYL1WXZpDKU/0fda9ce96cd847f8054704e85a05caa7/OnceUponaFarmSiloUS_22.jpg" class="" alt=""/>
      <ul>
      <li>Apply it to your back, neck, or chest before a steamy shower for a brisk aromatic experience.</li>
      <li>Add this rejuvenating scent to your fresh morning routine while you jump-start your day.</li>
      </ul>
      </div>
      `,
  },
  {
    index: 23,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/4nqWhJhTrDQq8gSMFc6iTE/da0f07fa8655c3d80047519f8a194f69/23_-_Ningxia-CN.jpg",
    title: "Ningxia Wolfberry Farm and Distillery",
    pdf: "https://static.youngliving.com/Farms/Ningxia-US-EN.pdf",
    content: `<p>Gary Young experienced the powerful benefits of wolfberries, native to China's remote Ningxia region. The ample irrigation provided by the Yellow River supports the natural production of wolfberries, wolfberry puree, and wolfberry seed oil.</p>
      <p>The Wolfberries from this farm are used in products like our Ningxia Red&reg; beverage.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/3jHfmGAINUGiyFEJrtXyiG/515d8bc1bbf9a02f888a6260bc9400b5/OnceUponaFarmSiloUS___23.jpg" class="" alt=""/>
      <ul>
      <li>Replace sugary drinks in the morning with a quick superfruit supplement.</li>
      <li>Make the most of school lunch with a nutritious snack that&rsquo;s mess free and easy to grab and go!&nbsp;</li>
      </ul>
      </div>
      `,
  },
  {
    index: 24,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/6uHaVmsWzCqAvTu6dkNA4k/aaa7cb1943e31ddeac83b8fe4588cbe3/12_-_Skyrider-Wilderness-Ranch-UT-US.jpg",
    title: "Golden Einkorn Farm",
    pdf: "https://static.youngliving.com/Farms/Golden-Einkorn-US-EN.pdf",
    content: `<p>Unlike highly processed flour found in supermarkets, Einkorn is a minimally processed ancient grain. This superior, subtly sweet grain, produced at the Golden Einkorn Farm, is unhybridized and rich in nutrients, making it exceptionally compatible with the human body. Just like Gary&rsquo;s &ldquo;true grit,&rdquo; this good-for-you grain is something everybody needs.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/6H2e5kjLKgpSetQIJd3IjC/5259c143a0dfe5bbed20f025a633dfd9/OnceUponaFarmSiloUS___24.jpg" class="" alt=""/>
      <p>Einkorn grain harvested from this farm is used in products like Gary&rsquo;s True Grit&reg;Einkorn Flour, Flakes, and Spaghetti.</p>
      </div>
      `,
  },
  {
    index: 25,
    img:
      "https://images.ctfassets.net/qx1dg9syx02d/1MFdb50eLnQ3WGnY0rEjXE/6d1cddf59ae94be5a695f2eb0802e618/25_YL-GHQ.jpg",
    title: "Young Living  Global Headquarters",
    pdf: "https://static.youngliving.com/Farms/GHQ-US-EN.mp4",
    content: `<p>We hope you&rsquo;ll carry the joy of the season&mdash;and a piece of our heritage&mdash;close to your heart as you share our legacy of wellness today, tomorrow, and into the new year.</p>
      <p>The journey doesn't end here.</p>
      <div class="slide-medialist">
      <img src="https://images.ctfassets.net/qx1dg9syx02d/76ebGO7wSZ9GV5L0Vc5bM0/a8afd6eaba67b36ca5dfbcf92c1e3c77/OnceUponaFarmSiloUS_25.jpg" class="" alt=""/>
      <ul>
      <li>Put several drops on a cotton ball and place it in the dirt tank of your vacuum so the scent will fill every room.</li>
      <li>Make a totally green air freshener with 15&minus;25 drops of Christmas Spirit and 1 tablespoon of witch hazel in 6 ounces of water.</li>
      </ul>
      </div>
      `,
  },
];

export const text = {
  chapter: "Chapter",
  pdfBlurb: "Learn more about this place",
  previousBtn: `Previous
    Chapter`,
  nextBtn: `Next
    Chapter`,
  skipChapter: `Skip to chapter:  `,
};
